export default __webpack_public_path__ + "static/abhaziya-celo-pskhu-cerkov-useknoveniya-glavy-ioanna-predtechi_3-1695ad356763429c068174e190a17d02.jpg";